<template>
  <div>
    <table-filter v-model="filter" :columns="columns"/>
    <div class="row justify-between">
      <div></div>
      <q-table-columns
          color="secondary"
          class="q-mr-sm"
          style="width: 100px;"
          v-model="visibleColumns"
          :columns="columns"
      />
    </div>
    <h-table
        :data="data"
        row-key="label"
        :columns="columns"
        :visible-columns="visibleColumns"
        :filter="filter"
        :pagination.sync="serverPagination"
        :rows-per-page-options="perPageOptions"
        :loading="loading"
        ref="table"
        @request="fetchData"
    >
    </h-table>
  </div>
</template>

<script>
  import tableHelpers from '@/HTable/helpers';
  import columns from './mixins/columns';
  import api from 'mixins/api';
  import {
    HTable,
    HTh
  } from '@';
  import TableFilter from '@/TableFilter';
  import {
    QTable,
    QTableColumns,
    QTr,
    QTh,
    QTd,
    QField,
    QInput,
    QCheckbox,
    QSelect,
    QSlider,
    QBtn,
    QIcon,
    QTooltip,
    QPopover,
    QModal
  } from 'quasar';

  export default {
    name: "LogsList",

    components: {
      QTable,
      QTableColumns,
      QTr,
      QTh,
      QTd,
      QField,
      QInput,
      QCheckbox,
      QSelect,
      QSlider,
      QBtn,
      QIcon,
      QTooltip,
      QPopover,
      QModal,
      HTable,
      HTh,
      TableFilter,
    },
    mixins: [
      columns,
      api,
      tableHelpers
    ],

    data() {
      return {
        visibleColumns: this.getVisibleColumns() || ['project_id', 'user_email', 'user_role', 'action_type', 'created_at'],
        serverPagination: {
          descending: false,
          page: 1,
          rowsNumber: 0, // specifying this determines pagination is server-side
          rowsPerPage: 20,
        },
      }
    },

    methods: {
      fetchData ({pagination, filter}) {
        this.query = this.getQuery(pagination, filter);
        this.loading = true;
        this.$http.get(this.createRequestUrl()).then((response) => {
          if (this.verifyResponse(response)) {
            this.updatePagination(pagination, response.data.total);
            this.updateData(response.data.logs);
            this.$store.commit('logsList/setData', response.data);
          }
          this.loading = false;
        }).catch(error => {
          const errors = error.response.data.errors;
          const notificationMessage = Object.values(errors).reduce((message, errorMessage) => {
            return message.concat(errorMessage + '\n');
          }, '');

          this.$q.notify({
            message: notificationMessage,
            timeout: 5000
          });

          console.error(error);

          this.loading = false;
        });
      },

      createRequestUrl() {
        if (this.isSingleLogView) {
          return `/api/v1.0/action-logs/${this.$route.params.id}/${this.query}`;
        }

        return `/api/v1.0/action-logs/${this.query}`;
      }
    },

    mounted () {
      this.fetchData({
        pagination: this.serverPagination,
        filter: this.filter
      });
    },
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/LogsList/LogsList.vue